import { useEffect, useState } from "react";
import CurrentDriverRoute from "./CurrentDriverRoute";
import { getCurrentDate } from "Helper";
import { useLazyGetActiveRoutesQuery } from "Data/services/routesApi";
import CustomLoader from "Components/CustomComponents/CustomLoader";
import NoDataFound from "Components/CustomComponents/NoDataFound";
import { RouteWithDriver } from "Data/interfaces";

const ActiveComponent: React.FC = () => {
  const [selectedDate] = useState<string>(getCurrentDate());
  const [routes, setRoutes] = useState<RouteWithDriver[]>([]);
  const [getPendingRoutes, { isFetching }] = useLazyGetActiveRoutesQuery();

  // console.log(routes);

  useEffect(() => {
    if (selectedDate) {
      getPendingRoutes({ date: selectedDate }).then(({ data }) => {
        setRoutes(data?.data || []);
      });
    }
  }, [selectedDate]);
  return (
    <div className="d-flex flex-column gap-2 mt-2">
      {isFetching && routes.length === 0 && <CustomLoader />}
      {!isFetching && routes.length === 0 && <NoDataFound />}

      {routes.map((route, index) => {
        return <CurrentDriverRoute key={index} route={route} />;
      })}
    </div>
  );
};

export default ActiveComponent;
